import { ArrowRight, Store } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";

/**
 * The way in for a shop that is not on SmartSpaza yet.
 *
 * Beside the sign-in card because this screen is what a till shows all day: a
 * neighbouring shopkeeper looking over the counter can scan it with their own
 * phone and apply there, which is where the form is meant to be filled in.
 *
 * The address is built from wherever this page was served, not written in, so
 * the code a till shows always leads to the server that till belongs to.
 *
 * On a phone the code is dropped — nobody scans their own screen — and only the
 * link remains, under the card.
 */
export function ApplyInvite() {
  const applyUrl = `${window.location.origin}/apply`;

  return (
    <aside
      aria-labelledby="apply-invite-title"
      className="w-full rounded-[1.375rem] bg-surface p-5 shadow-pop"
    >
      <div className="flex items-center gap-2 lg:flex-col lg:text-center">
        <Store className="size-5 shrink-0 text-brand-500 lg:size-6" aria-hidden />
        <div>
          <h2 id="apply-invite-title" className="text-sm font-semibold text-ink-900">
            New to SmartSpaza?
          </h2>
          <p className="mt-0.5 text-xs text-ink-500">
            <span className="hidden lg:inline">Scan with your phone to apply.</span>
            <span className="lg:hidden">Apply for your shop in a few minutes.</span>
          </p>
        </div>
      </div>

      <div className="mt-4 hidden justify-center lg:flex">
        <QRCodeSVG
          value={applyUrl}
          size={148}
          // Navy on white rather than brand teal: scanners read contrast, and a
          // dim till screen under shop lighting is the worst case to design for.
          fgColor="#02142A"
          bgColor="#FFFFFF"
          marginSize={2}
          title={`QR code for ${applyUrl}`}
          className="rounded-md"
        />
      </div>

      <Link
        to="/apply"
        className="mt-4 inline-flex h-touch-lg w-full items-center justify-center gap-2 rounded-control bg-gold-500 px-4 text-sm font-semibold text-navy-800 shadow-card transition-colors hover:brightness-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500/40"
      >
        Apply now
        <ArrowRight className="size-4" aria-hidden />
      </Link>
    </aside>
  );
}
